<template>
  <SubSidebarLayout :menu-categories="menuCategories" />
</template>
<script>
import SubSidebarLayout from '@/components/sidebars/SubSidebarLayout'

export default {
  components: {
    SubSidebarLayout
  },
  data: () => ({
    menuCategories: [
      {
        name: '記事を書く',
        items: [{ text: '記事一覧', router: { name: 'adminPosts' } }]
      },
      {
        name: '発注する',
        items: [
          {
            text: '一括発注',
            situation: 'order_management',
            router: { name: 'adminOrderRegistrations' }
          },
          {
            text: '発注一覧',
            situation: 'order_management',
            router: { name: 'adminOrders' }
          }
        ]
      },
      {
        name: '関連設定',
        items: [
          {
            text: 'カテゴリ・タグ',
            situation: 'tag_management',
            router: { name: 'adminTags' }
          },
          {
            text: 'タググループ',
            situation: 'tag_management',
            router: { name: 'adminTagGroups' }
          },
          {
            text: '一括タグ追加',
            situation: 'tag_management',
            router: { name: 'adminTagsAssignment' }
          },
          {
            text: '画像',
            situation: 'picture_management',
            router: { name: 'adminPicture' }
          },
          {
            text: 'ウィジェット',
            situation: 'widget_management',
            router: { name: 'adminWidgets' }
          },
          {
            text: 'キャラクター設定',
            situation: 'character_image_management',
            router: { name: 'adminCharacters' }
          },
          {
            text: 'レギュレーションチェック一覧',
            situation: 'regulation_check_management',
            router: { name: 'adminRegulationChecks' }
          }
        ]
      },
      {
        name: '記事をまとめる',
        items: [
          {
            text: '特集',
            situation: 'feature_management',
            router: { name: 'adminFeatures' }
          },
          {
            text: '記事リスト',
            situation: 'post_list_management',
            router: { name: 'adminPostGroups' }
          }
        ]
      }
    ]
  })
}
</script>
